import React from "react";
import { connect } from "react-redux";
import { List } from "immutable";
import { history } from "/app/src/store";
import { Flex, Pagination } from "/app/src/component";
import Item from "./Item";
import style from "./style.css";
import UserModel from "/app/src/model/User/model";
import UserSelector from "/app/src/model/User/selector";
import getQueryVariable from "/app/src/lib/urlparser";
import Spinner from "/app/src/component/Spinner";

class SearchCustomer extends React.Component {
  constructor(props) {
    super(props);
    this._renderResults = this._renderResults.bind(this);
    this._onPaginationClick = this._onPaginationClick.bind(this);
    this._onItemClick = this._onItemClick.bind(this);

    this.state = {
      currentPage: 1,
      activeItemId: 0,
    };
  }

  _onItemClick(id) {
    const terms = getQueryVariable(this.props.location.search, "terms");
    this.setState({ activeItemId: id });
    history.push({
      search: `terms=${terms}&id=${id}`,
    });
  }

  _renderPagination() {
    return (
      <Flex>
        <Pagination
          marginTop="auto"
          itemCounts={this.props.resultCount}
          itemPerPage={10}
          currentPage={this.state.currentPage}
          onClick={this._onPaginationClick}
        />
      </Flex>
    );
  }

  _renderResults() {
    const searchResults = this.props.searchResults.get("customers");
    const terms = getQueryVariable(this.props.location.search, "terms");

    if (searchResults.size === 0)
      return (
        <Flex grow center height="30vh">
          {`Din sökning på "${terms}" på matchade inga resultat. Kontrollera sökorden.`}
        </Flex>
      );

    return (
      <Flex
        className={style.ResultWrapper}
        column
        width="100%"
        overflow="auto"
        basis="max-content"
      >
        {searchResults.map((e, index) => (
          <Item
            key={index}
            activeItemId={this.state.activeItemId}
            id={e.get("id")}
            companyCustomerId={e.get("company_customer_id")}
            name={e.get("name")}
            phone={e.get("phone")}
            email={e.get("email")}
            onClick={() => this._onItemClick(e.get("id"))}
          />
        ))}
        {this.props.resultCount > 10 && this._renderPagination()}
      </Flex>
    );
  }

  _onPaginationClick() {
    const terms = getQueryVariable(this.props.location.search, "terms");
    history.push({
      search: `terms=${terms}`,
    });
    this.props.dispatch(
      UserModel.searchBy(terms.split(" "), this.state.currentPage)
    );
  }

  render() {
    const resultsHeader = List([
      "Besökar ID",
      "Namn",
      "Telefonnummer",
      "Email",
    ]);
    return (
      <Flex column id="mainpanel-search-customer" grow>
        <Flex className={style.sorting} shrink={0}>
          {resultsHeader.map((e, i) => (
            <Flex center width="25%" key={i}>
              {e}
            </Flex>
          ))}
        </Flex>
        {this.props.searchIsFetching ? (
          <Flex center basis="30vh">
            <Spinner />
          </Flex>
        ) : (
          this._renderResults()
        )}
      </Flex>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const results = UserSelector.searchResults(state);
  const count = results.get("customers_total_count");

  return {
    searchResults: results,
    searchIsFetching: UserSelector.searchIsFetching(state),
    resultCount: count,
  };
}
export default connect(mapStateToProps, null)(SearchCustomer);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/Search/Customer/index.js